import { until, useAsyncState } from '@vueuse/core'
import { defineStore, storeToRefs } from 'pinia'

//!nordy - isCloud, useFirebaseAuthStore 미사용 (nordy는 별도 인증 플로우 사용)
// import { isCloud } from '@/platform/distribution/types'
// import { useFirebaseAuthStore } from '@/stores/firebaseAuthStore'
import { useSettingStore } from '@/platform/settings/settingStore'
import { api } from '@/scripts/api'
import { useUserStore } from '@/stores/userStore'
//!nordy - 유저 스토어, 세션 스토리지 클리어
import { useNordyUserStore } from '@/nordy/store/nordyUserStore'
import { clearSessionStorageForNordy } from '@/nordy/nordy.global'

export const useBootstrapStore = defineStore('bootstrap', () => {
  const settingStore = useSettingStore()

  const {
    isReady: isI18nReady,
    error: i18nError,
    execute: loadI18n
  } = useAsyncState(
    async () => {
      const { mergeCustomNodesI18n } = await import('@/i18n')
      const i18nData = await api.getCustomNodesI18n()
      mergeCustomNodesI18n(i18nData)
    },
    undefined,
    { immediate: false }
  )

  let storesLoaded = false

  function loadAuthenticatedStores() {
    if (storesLoaded) return
    storesLoaded = true
    void settingStore.load()
  }

  async function startStoreBootstrap() {
    clearSessionStorageForNordy() //!nordy

    const userStore = useUserStore()
    await userStore.initialize()

    const { needsLogin } = storeToRefs(userStore)
    await until(needsLogin).toBe(false)

    void loadI18n()
    loadAuthenticatedStores()

    //!nordy - 유저 정보와 크레딧을 모두 로드 (syncWorkflows에서 general/public 분기 및 프롬프트 실행 시 크레딧 검증에 필요)
    const nordyUserStore = useNordyUserStore()
    const nordyUser = await nordyUserStore.loadNordyUser()
    if (nordyUser) {
      await nordyUserStore.getActiveCredit()
    }
  }

  return {
    isI18nReady,
    i18nError,
    startStoreBootstrap
  }
})
